import actions from "./actions";

const {
    FETCH_INCREMENT_MONTH_DECLARATIONS,
    FETCH_INCREMENT_MONTH_DECLARATION,
    RESET_INCREMENT_MONTH_DECLARATION
} = actions;

const initState = {
    incrementMonthDeclarations: {
        page: 0,
        perPage: 35,
        data: [],
        total: 0
    },
    incrementMonthDeclaration: { _id: null }
};

const IncrementMonthDeclarationReducer = (state = initState, action) => {
    const { type, data } = action;

    switch (type) {
        case FETCH_INCREMENT_MONTH_DECLARATIONS:
            return {
                ...state,
                incrementMonthDeclarations: data
            };
        case RESET_INCREMENT_MONTH_DECLARATION:
            return {
                ...state,
                incrementMonthDeclaration: initState.incrementMonthDeclaration
            };
        case FETCH_INCREMENT_MONTH_DECLARATION:
            return {
                ...state,
                incrementMonthDeclaration: data
            };
        default:
            return state;
    }
};

export default IncrementMonthDeclarationReducer;
